export const BEGIN_LOGIN = "BEGIN_LOGIN";
export const END_LOGIN_SUCCESS = "END_LOGIN_SUCCESS";
export const END_LOGIN_ERROR = "END_LOGIN_ERROR";
export const LOGOUT = "LOGOUT";

export interface Account {
    accountIdentifier: string;
    homeAccountIdentifier: string;
    userName: string;
    idTokenClaims: object;
    name: string;
    sid: string;
    environment: string;
}

export interface Authentication {
    isLoggingIn?: boolean;
    error: string | null;
    account?: Account | null;
}

interface BeginLoginAction {
    type: typeof BEGIN_LOGIN;
}

interface EndLoginSuccessAction {
    type: typeof END_LOGIN_SUCCESS;
    account?: Account | null;
}

interface EndLoginErrorAction {
    type: typeof END_LOGIN_ERROR;
    error: string;
}

interface LogoutAction {
    type: typeof LOGOUT;
}

export type AuthenticationActionTypes = BeginLoginAction | EndLoginSuccessAction | EndLoginErrorAction | LogoutAction;
